<template>
  <div class="mg-dropdown-button">
    <el-button v-bind="$attrs" @click="handleClick" v-if="!showIcon">
      <slot />
    </el-button>
    <el-dropdown v-on="$listeners" v-else @after-command="afterCommand">
      <el-button v-bind="$attrs" @click="handleImmediateClick">
        <slot />
        <i class="el-icon-arrow-down el-icon--right" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in data" v-bind="item" :key="item.command" :command="item">
          <template v-if="!item.children">
            {{ item.label }}
          </template>
          <template v-else>
            <el-dropdown v-on="$listeners">
              <span>
                {{ item.label }}
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="sonItem in item.children"
                  v-bind="sonItem"
                  :key="sonItem.command"
                  :command="sonItem"
                >
                  {{ sonItem.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    name: 'MgDropdownButton',
    props: {
      data: Array,
      // 缓存数据的key
      cacheKey: String,
    },
    computed: {
      showIcon() {
        return this.$attrs.icon || !this.isDropdown
      },
      isDropdown() {
        return !this.data?.length
      },
    },
    methods: {
      handleCommand(command) {
        this.$emit('command', command)
      },
      afterCommand(command) {
        if (this.cacheKey) {
          const { setStorage } = this.$MGUI?.dropdownButton
          if (typeof setStorage === 'function') {
            setStorage(this.cacheKey, command)
          }
        }
      },
      handleClick() {
        if (this.isDropdown) {
          this.handleCommand()
        }
      },
      handleImmediateClick() {
        if (this.cacheKey) {
          const { getStorage } = this.$MGUI?.dropdownButton
          if (typeof getStorage === 'function') {
            const printTempId = getStorage(this.cacheKey)
            let command = this.data[0]
            if (printTempId) {
              command = this.data.find((item) => item.printTemplateId == printTempId)
            }
            this.handleCommand(command)
            this.afterCommand(command)
          }
        }
      },
    },
  }
</script>

<style lang="scss">
  .mg-dropdown-button + * {
    margin-left: 10px;
  }
  .el-button + .mg-dropdown-button {
    margin-left: 10px;
  }
  .mg-dropdown-button {
    display: inline-block;
    line-height: 1;
    .el-dropdown {
      .el-button--mini {
        padding: 2px 0;
      }
      .el-button--icon {
        display: flex;
        align-items: center;
      }
    }
  }
</style>
